import React, { useEffect, useState } from 'react';
import { SavedViewSelection } from './SavedViewSelection';
import { SelectItem } from '../../../../types';
import { filterSelectItems } from '../../../../utils';
import { LoadingPage } from '../../../Shared';
import { IModelsApi } from '../../../../apis';

export interface SavedViewSelectionContainerProps {
  projectId: string;
  iModelId: string;
  selected?: string;
  tabConfigured: boolean;
  setDefaultViewId: (savedView: string) => void;
}

export function SavedViewSelectionContainer({
  projectId,
  iModelId,
  selected,
  tabConfigured,
  setDefaultViewId,
}: SavedViewSelectionContainerProps): JSX.Element {
  const [items, setItems] = useState<SelectItem[]>([]);
  const [displayedItems, setDisplayedItems] = useState<SelectItem[]>([]);
  const [filter, setFilter] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);

  const init = async () => {
    let savedViews: SelectItem[] = (
      await IModelsApi.fetchIModelViews(projectId, iModelId)
    ).map(savedView => ({
      value: savedView.instanceId,
      text: savedView.name,
      icon: savedView.thumbnail,
      onClick: () => setDefaultViewId(savedView.instanceId),
    }));

    const defaultView: SelectItem = {
      value: '-1',
      text: 'Default View',
      onClick: () => setDefaultViewId('-1'),
    };

    savedViews = [defaultView, ...savedViews];
    selected ?? setDefaultViewId(savedViews[0]?.value);
    setItems(savedViews);
    setDisplayedItems(savedViews);
    setLoading(false);
  };

  useEffect(() => {
    init().catch(error => console.error(error));
  }, []);

  useEffect(() => {
    setDisplayedItems(filterSelectItems(items, filter));
  }, [filter]);

  const onSearch = async (input: string = '') => {
    setFilter(input);
  };

  const onClear = async () => {
    setFilter('');
  };

  const onChange = async (input: string = '') => {
    setFilter(input);
  };

  if (loading) {
    return <LoadingPage subtext='Fetching saved views...' fullscreen />;
  }

  return (
    <SavedViewSelection
      tabConfigured={tabConfigured}
      items={displayedItems}
      selected={selected}
      onSearch={onSearch}
      onClear={onClear}
      onChange={onChange}
    />
  );
}
